import React, { useEffect } from "react";
import "./Bootcamp.css";

const Bootcamp = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
        const navbar = document.querySelector("header, .navbar");
        const footer = document.querySelector("footer");
    
        if (navbar) navbar.style.display = "none";
        if (footer) footer.style.display = "none";
    
        return () => {
          if (navbar) navbar.style.display = "";
          if (footer) footer.style.display = "";
        };
      }, []);

  const checkoutUrl =
    "/bootcamp-payment";

  return (
    <main className="fyp-bootcamp">

      {/* =====================================================
          NAVBAR
      ===================================================== */}
      <header className="bootcamp-navbar">

        <div className="bootcamp-navbar-container">

          {/* LOGO */}
          <a
            href="#bootcamp"
            className="bootcamp-logo"
          >
            <img
              src="/Logo.png"
              alt="ForgeYourPeak"
              className="bootcamp-logo-img"
            />

            <span>
              Forge<span>Your</span>Peak
            </span>
          </a>


          {/* NAVIGATION */}
          <nav className="bootcamp-nav-links">

            <a href="#bootcamp">
              Bootcamp
            </a>

            <a href="#how-it-works">
              How It Works
            </a>

            <a href="#what-you-get">
              What You Get
            </a>

            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="navbar-join-btn">
                Join Bootcamp — ₹499
              </button>
            </a>

          </nav>

        </div>

      </header>


      {/* =====================================================
          HERO
      ===================================================== */}
      <section
        className="bc-hero"
        id="bootcamp"
      >

        <div className="bc-hero-container">

          {/* HERO CONTENT */}
          <div className="bc-hero-copy">

            <div className="bc-badge">
              3-DAY VISUAL PERFORMANCE BOOTCAMP
            </div>


            <h1 className="bc-title">
              Reset Your Eyes.
              <br />

              <span>
                React Faster.
              </span>

              <br />

              Perform Sharper.
            </h1>


            <p className="bc-sub">
              3-Day neuroscience based performance reset
              for competitive athletes.
            </p>


            {/* =================================================
                BENEFITS
            ================================================= */}
            <div className="bc-benefits">

              {/* BETTER FOCUS */}
              <div className="bc-benefit-card">

                <div className="bc-benefit-icon">
                  👁
                </div>

                <span>
                  Better Focus
                </span>

              </div>


              {/* FASTER REACTIONS */}
              <div className="bc-benefit-card">

                <div className="bc-benefit-icon reaction-icon">
                  ⚡
                </div>

                <span>
                  Faster Reactions
                </span>

              </div>


              {/* IMPROVED PERFORMANCE */}
              <div className="bc-benefit-card">

                <div className="bc-benefit-icon performance-icon">
                  📈
                </div>

                <span>
                  Improved Performance
                </span>

              </div>

            </div>


            {/* CTA */}
            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bc-main-btn"
            >
              Join Bootcamp for ₹499 →
            </a>

          </div>


          {/* =================================================
              HERO IMAGE
          ================================================= */}
          <div className="bc-hero-image-wrap">

            <img
              src="/FYP-Bootcamp/bootcamp_athlete_image.png"
              alt="Visual Performance Bootcamp"
              className="bc-hero-image"
            />

          </div>

        </div>

      </section>


      {/* =====================================================
          PROBLEM SECTION
      ===================================================== */}
      <section className="bc-problem">

        <div className="bc-container">

          <h2 className="bc-problem-title">

            Most Athletes Train Their Body.

            <br />

            <span>
              Few Train Their Visual System.
            </span>

          </h2>


          {/* PROBLEM CHIPS */}
          <div className="bc-chips">

            <div className="bc-chip">
              Late Ball Pickup
            </div>

            <div className="bc-chip">
              Slow First Step
            </div>

            <div className="bc-chip">
              Inconsistent Timing
            </div>

            <div className="bc-chip">
              Eye Fatigue
            </div>

            <div className="bc-chip">
              Poor Decision Clarity
            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          3 DAY PROGRAM
      ===================================================== */}
      <section
        className="bc-days"
        id="how-it-works"
      >

        <div className="bc-container">

          {/* SECTION HEADING */}
          <div className="bc-section-heading">

            <div className="bc-small-badge">
              3-DAY PROGRAM
            </div>

            <h2>
              What Happens in 3 Days
            </h2>

            <p>
              Each day builds on the last. By Day 3 you have
              a match-day visual reset protocol you can use
              immediately — before every game, every session,
              every competition.
            </p>

          </div>


          {/* =================================================
              DAY 1 — TEST
          ================================================= */}
          <div className="bc-day-card">

            <div className="bc-day-content">

              <span className="bc-day-number">
                DAY 1
              </span>

              <h3>
                Test
              </h3>

              <ul>

                <li>
                  Measure visual clarity
                </li>

                <li>
                  Measure neural-processing speed
                </li>

                <li>
                  Benchmark your baseline
                </li>

              </ul>

            </div>


            <div className="bc-day-image">

              <img
                src="/FYP-Bootcamp/Measure.png"
                alt="Day 1 Test"
              />

            </div>

          </div>


          {/* =================================================
              DAY 2 — TRAIN
          ================================================= */}
          <div className="bc-day-card">

            <div className="bc-day-content">

              <span className="bc-day-number">
                DAY 2
              </span>

              <h3>
                Train
              </h3>

              <ul>

                <li>
                  Learn to rest your visual system
                </li>

                <li>
                  Improve hand-eye coordination
                </li>

                <li>
                  Train your brain for faster reactions
                </li>

              </ul>

            </div>


            <div className="bc-day-image">

              <img
                src="/FYP-Bootcamp/Train.png"
                alt="Day 2 Train"
              />

            </div>

          </div>


          {/* =================================================
              DAY 3 — TRANSFORM
          ================================================= */}
          <div className="bc-day-card">

            <div className="bc-day-content">

              <span className="bc-day-number">
                DAY 3
              </span>

              <h3>
                Transform
              </h3>

              <ul>

                <li>
                  Match-day carryover plan
                </li>

                <li>
                  Basic visual reset protocol
                </li>

              </ul>

            </div>


            <div className="bc-day-image">

              <img
                src="/FYP-Bootcamp/Transform.png"
                alt="Day 3 Transform"
              />

            </div>

          </div>


          {/* =================================================
              QUOTE
          ================================================= */}
          <div className="bc-quote">

            <p>
              "Your body is ready. Is your visual system?"
            </p>

            <span>
              — The question most coaches never ask.
            </span>

          </div>


          {/* CTA */}
          <div className="bc-center-btn">

            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bc-main-btn"
            >
              Start a Bootcamp — ₹499 →
            </a>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHAT YOU GET
      ===================================================== */}
      <section
        className="bc-get"
        id="what-you-get"
      >

        <div className="bc-container">

          <div className="bc-section-heading">

            <div className="bc-small-badge">
              BOOTCAMP BENEFITS
            </div>

            <h2>
              What You Get
            </h2>

            <p>
              A focused 3-day visual performance reset
              designed to build better visual habits
              and faster reactions.
            </p>

          </div>


          <div className="bc-get-grid">

            <div className="bc-get-card">

              <span>
                ✓
              </span>

              3-Day Guided Visual Reset System

            </div>


            <div className="bc-get-card">

              <span>
                ✓
              </span>

              Visual Fatigue Recovery Protocol

            </div>


            <div className="bc-get-card">

              <span>
                ✓
              </span>

              Reaction Trigger Activation Drills

            </div>


            <div className="bc-get-card">

              <span>
                ✓
              </span>

              Self-Check Progress Framework

            </div>


            <div className="bc-get-card">

              <span>
                ✓
              </span>

              Access to Private Athlete Community

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}
      <section className="bc-final">

        <div className="bc-container">

          {/* FOOTER IMAGE */}
          <img
            src="/FYP-Bootcamp/Footer.png"
            alt="Bootcamp"
            className="bc-footer-image"
          />


          {/* FINAL CTA CONTENT */}
          <div className="bc-final-content">

            <div className="bc-small-badge">
              READY?
            </div>

            <h2>

              Your Body Is Ready.

              <br />

              <span>
                Is Your Visual System?
              </span>

            </h2>


            <p>
              Start your 3-day visual performance bootcamp
              and build a reset routine you can use before
              every game, session and competition.
            </p>


            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bc-main-btn"
            >
              Start Now – ₹499 →
            </a>

          </div>

        </div>


        {/* =================================================
            FOOTER
        ================================================= */}
        <footer className="bc-footer">

          <div className="bc-footer-logo">

            <img
              src="/Logo.png"
              alt="ForgeYourPeak"
            />

            <strong>
              Forge<span>YourPeak</span>
            </strong>

          </div>


          <p>
            © 2026 forgeyourpeak.in · All rights reserved
          </p>

        </footer>

      </section>

    </main>
  );
};

export default Bootcamp;